function getOrdinalSuffix(date) {
    const day = new Date(date).getDate();
    switch (day) {
        case 1:
        case 21:
        case 31:
            return 'st';
        case 2:
        case 22:
            return 'nd';
        case 3:
        case 23:
            return 'rd';
        default:
            return 'th';
    }
}

export default () => getOrdinalSuffix;



// WEBPACK FOOTER //
// ./src/js/components/common/ordinalfilter/index.js